module.exports = __webpack_public_path__ + "img/gold.d5d2c666.png";